import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import axios from 'axios';
import { DASHBOARD_EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  FETCH_SHIP_TO_DETAILS_BEGIN,
  FETCH_SHIP_TO_DETAILS_SUCCESS,
  FETCH_SHIP_TO_DETAILS_FAILURE,
  FETCH_SHIP_TO_DETAILS_DISMISS_ERROR,
} from './constants';

export function fetchShipToDetails(params) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_SHIP_TO_DETAILS_BEGIN,
    });

    const { siteNumber, shipToNumber } = params;
    const apiUrl = `${DASHBOARD_EXPORT_API_REQUEST_URL}/customers/${shipToNumber}/${siteNumber}`;

    const cognitoIdToken = getState().home.auth.cognitoIdToken;
    const token = `Bearer ${cognitoIdToken}`;

    const promise = axios.get(apiUrl, {
      // headers: {
      //   'Authorization': token,
      // }
        params:{
          _t: new Date().getTime(), // prevent caching
        },
      headers: {
        'Authorization': token,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    })
      .then((res) => {
        // Check if status is success
        if (res.data.status === 'success') {
          dispatch({
            type: FETCH_SHIP_TO_DETAILS_SUCCESS,
            data: res.data.data,
          });
          return res.data.data;

} else {
          // Handle 'fail' status from API (Response 1)
          const errorMessage = res.data.data?.message || 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: FETCH_SHIP_TO_DETAILS_FAILURE,
            data: { error: errorMessage },
          });
          throw new Error(errorMessage);
        }
      })
      .catch((err) => {
        // Handle network errors or other exceptions
        // Response 2: err.response.data.description.data.message
        // Response 1: err.response.data.data.message
        const errorMessage = err?.response?.data?.description?.data?.message || 
                            err?.response?.data?.data?.message || 
                            err?.response?.data?.message ||
                            err?.message ||
                            'There is an error. Please refresh page or contact administrator.';
        
        dispatch({
          type: FETCH_SHIP_TO_DETAILS_FAILURE,
          data: { error: errorMessage },
        });
        throw err;
      });

    return promise;
  };
}

export function dismissFetchShipToDetailsError() {
  return {
    type: FETCH_SHIP_TO_DETAILS_DISMISS_ERROR,
  };
}

export function useFetchShipToDetails() {
  const dispatch = useDispatch();

  const { shipToDetails, fetchShipToDetailsPending, fetchShipToDetailsError } = useSelector(
    state => ({
      shipToDetails: state.iaSTIInquiry?.shipToDetails,
      fetchShipToDetailsPending: state.iaSTIInquiry?.fetchShipToDetailsPending,
      fetchShipToDetailsError: state.iaSTIInquiry?.fetchShipToDetailsError,
    }),
    shallowEqual
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(fetchShipToDetails(...args));
    },
    [dispatch]
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchShipToDetailsError());
  }, [dispatch]);

  return {
    shipToDetails,
    fetchShipToDetails: boundAction,
    fetchShipToDetailsPending,
    fetchShipToDetailsError,
    dismissFetchShipToDetailsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FETCH_SHIP_TO_DETAILS_BEGIN:
      return {
        ...state,
        fetchShipToDetailsPending: true,
        fetchShipToDetailsError: null,
      };

    case FETCH_SHIP_TO_DETAILS_SUCCESS:
      return {
        ...state,
        shipToDetails: action.data,
        fetchShipToDetailsPending: false,
        fetchShipToDetailsError: null,
      };

    case FETCH_SHIP_TO_DETAILS_FAILURE:
      return {
        ...state,
        fetchShipToDetailsPending: false,
        fetchShipToDetailsError: action.data.error,
      };

    case FETCH_SHIP_TO_DETAILS_DISMISS_ERROR:
      return {
        ...state,
        fetchShipToDetailsError: null,
      };

    default:
      return state;
  }
}

